// extracted by mini-css-extract-plugin
export default {"list":"ErrorList-module--list--d7d87","listItem":"ErrorList-module--list-item--4acb6"};